import { REDEPLOY_APP_WITH_PACKAGE_WARNING } from "ee/constants/messages";
import {
  REDEPLOY_TRIGGERS as CE_REDEPLOY_TRIGGERS,
  REDEPLOY_WARNING_MESSAGE as CE_REDEPLOY_WARNING_MESSAGE,
  REDEPLOY_DOC_URL as CE_REDEPLOY_DOC_URL,
} from "ce/constants/DeploymentConstants";

export const REDEPLOY_TRIGGERS = {
  ...CE_REDEPLOY_TRIGGERS,
  PendingDeploymentWithPackage: "PENDING_DEPLOYMENT_WITH_PACKAGE",
} as const;

type ValueOf<T> = T[keyof T];
export type RedeployTriggerValue = ValueOf<typeof REDEPLOY_TRIGGERS>;

export const REDEPLOY_WARNING_MESSAGE: Record<
  RedeployTriggerValue,
  () => string
> = {
  ...CE_REDEPLOY_WARNING_MESSAGE,
  [REDEPLOY_TRIGGERS.PendingDeploymentWithPackage]:
    REDEPLOY_APP_WITH_PACKAGE_WARNING,
};

export const REDEPLOY_DOC_URL: Record<RedeployTriggerValue, string> = {
  ...CE_REDEPLOY_DOC_URL,
  [REDEPLOY_TRIGGERS.PendingDeploymentWithPackage]:
    "https://docs.appsmith.com/packages/reference/best-practices-git-packages#synchronizing-package-updates",
};
